import { Dropdown } from 'framework/form';
import type { FillInputProps } from '../fillInput';
import { numberOf } from '../shared/bounds';
import { inListOrder } from '../shared/choice';

export const MultiselectInput = (props: FillInputProps<string[], object>) => {
  const { options, value, onChange, onBlur, inputId, label, showLabel, disabled, required, error } = props;
  const max = numberOf(props.bounds.max);
  const atMax = max !== undefined && value.length >= max;
  return (
    <Dropdown
      {...props}
      source={inputId}
      label={showLabel ? label : ''}
      multiple
      options={options.map(option => ({
        value: option.id,
        label: option.label,
        disabled: atMax && !value.includes(option.id),
      }))}
      value={value}
      onChangeCallback={values => onChange(inListOrder(values[inputId] ?? [], options))}
      validationCallback={onBlur}
      placeholder="Select..."
      disabled={disabled}
      isRequired={required}
      errorMessages={error ? [''] : []}
      sx={{ mb: 0 }}
    />
  );
};
